import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const RestoreButton = forwardRef(({ active, className, ...props }, ref) => {
  const icon = active ? 'redo' : 'check';
  const btnClassName = cn('restore-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='restore-button'
      themeColor='secondary'
      disabled={!active}
      className={btnClassName}
      icon={icon}
      {...props}
    />
  );
});

export default RestoreButton;
